import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import { Box } from '@mui/material';
import { setCell } from './cellRenderer';
import { isCheckQuant } from '../../../config';
/**
 * Компонент для відображення одного рядка таблиці
 */
export const TableDataRow = ({
    row,
    index,
    columns,
    isPointCursor,
    setClickRow,
    cellBtnActionByType,
    l,
    handleClickOpenImage,
    language,
    isBasket,
}) => {
    return (
        <TableRow
            hover={isPointCursor}
            sx={{
                cursor: isPointCursor ? 'pointer' : 'default',
                ...(row._ghost ? {
                    backgroundColor: '#f0f7ff',
                    borderLeft: '3px solid #2196f3',
                    opacity: 0.9,
                } : row.redBorder ? { backgroundColor: '#ffeaea' } : {}),
                ...(isBasket && isCheckQuant === '1' && row.QUANT < row.FMINQTY ? { backgroundColor: 'rgb(253, 237, 237)' } : {}),
            }}
            onClick={() => {
                if (setClickRow) {
                    setClickRow(row);
                }
            }}
            role="checkbox"
            tabIndex={-1}
            key={row.id || index}
        >
            {columns.map((column) => {
                const value = row[column.id];
                return (
                    <TableCell
                        sx={{
                            py: 1,
                            px: { xs: 0.5, xl: 1 },
                            fontSize: { xs: '0.8125rem', xl: '0.875rem' },
                        }}
                        key={`${row.id}-${column.id}`}
                    >
                        <Box
                            justifyContent={column?.align}
                            sx={{ display: 'flex' }}
                            alignItems={'center'}
                        >
                            {setCell({
                                type: column.type,
                                data: value,
                                action: cellBtnActionByType,
                                row,
                                l,
                                handleClickOpenImage,
                                language,
                                index,
                                redBorder: row.redBorder,
                            })}
                        </Box>
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

/**
 * Компонент для відображення skeleton під час завантаження
 */
export const TableSkeletonRows = ({ columns, rowCount = 3 }) => {
    return (
        <>
            {Array(rowCount)
                .fill(0)
                .map((_, i) => (
                    <TableRow key={i}>
                        {columns.map((_, j) => (
                            <TableCell key={`${i}-${j}`} sx={{ margin: '10px 0px' }}>
                                <Skeleton variant="rounded" width="100%" height={20} />
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
        </>
    );
};

/**
 * Компонент для відображення повідомлення про порожню таблицю
 */
export const TableEmptyRow = ({ columns, tableEmptyText }) => {
    return (
        <TableRow>
            <TableCell colSpan={columns.length} sx={{ backgroundColor: '#f5f5f5' }}>
                <Typography
                    marginTop={2}
                    color="grey"
                    margin={0}
                    textAlign="center"
                    component="p"
                    variant="h5"
                >
                    {tableEmptyText}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

/**
 * Компонент для відображення простого списку рядків (не priceList)
 */
export const SimpleTableBody = ({
    rows,
    columns,
    page,
    rowsPerPage,
    isPointCursor,
    setClickRow,
    cellBtnActionByType,
    l,
    handleClickOpenImage,
    language,
    tableEmptyText,
    isBasket,
}) => {
    // rows ще завантажуються
    if (rows === undefined || rows === null) {
        return <TableSkeletonRows columns={columns} />;
    }

    // rows завантажилися, але порожні
    if (rows.length === 0) {
        return <TableEmptyRow columns={columns} tableEmptyText={tableEmptyText} />;
    }

    const paginatedRows = rows;

    // є дані для відображення
    // const paginatedRows = rows.slice(
    //     (page - 1) * rowsPerPage,
    //     (page - 1) * rowsPerPage + rowsPerPage
    // );

    return (
        <>
            {paginatedRows.map((row, i) => {
                if (row._divider) {
                    return (
                        <TableRow key={row.id || `_divider_${i}`}>
                            <TableCell
                                colSpan={columns.length}
                                sx={{
                                    backgroundColor: '#e3f2fd',
                                    borderTop: '2px solid #2196f3',
                                    borderBottom: '2px solid #2196f3',
                                    py: 1,
                                    px: 2,
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: '#1565c0', fontWeight: 600, letterSpacing: 0.3 }}
                                >
                                    {l('Recommendations based on your purchases')}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    );
                }
                return (
                    <TableDataRow
                        key={row.id || i}
                        row={row}
                        index={i}
                        columns={columns}
                        isPointCursor={isPointCursor}
                        setClickRow={setClickRow}
                        cellBtnActionByType={cellBtnActionByType}
                        l={l}
                        handleClickOpenImage={handleClickOpenImage}
                        language={language}
                        isBasket={isBasket}
                    />
                );
            })}
        </>
    );
};

export default SimpleTableBody;
